"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _createPalette = _interopRequireDefault(require("@material-ui/core/styles/createPalette"));

var _flow2 = _interopRequireDefault(require("lodash/flow"));

var _ensureColors = _interopRequireDefault(require("./ensureColors"));

var _skipperDefaultPalette = _interopRequireDefault(require("./skipperDefaultPalette"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _flow2["default"])(function () {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _deepmerge["default"])(_skipperDefaultPalette["default"], p);
}, _ensureColors["default"], _createPalette["default"]);

exports["default"] = _default;